import React from "react";

/**
 * Logo component that displays the application logo in the sidebar
 * Renders a clickable logo image that links to the home page

 */
const Logo = () => (
    <div className="sidepanel-image background-white">
        <a href="/">
            <img src="/images/logo-new.png" className="img-fluid" />
        </a>
    </div>
);

export default Logo;
